_ = require 'underscore'
{ PowerUpItemType } = require 'common/components/power-up'
BaseDirectoryView = require './base-directory-view'
DirectoryPluginItemView = require './directory-plugin-item-view'
React = require 'react'
t = require('views/internal/recup-with-helpers')('directory')

class DirectoryPageComponent extends React.Component
  displayName: 'Directory Page'

  render: t.renderable ->
    t.div '.directory-content-body', =>
      t.div '.directory-listing'

module.exports = class DirectoryCategoryView extends BaseDirectoryView
  renderContent: ->
    React.createElement DirectoryPageComponent, {
      title: @options.title
    }

  render: ->
    super
    contentContainer = @$el.find('.directory-listing')
    contentContainer.empty()

    { plugins, currentPage, directoryView } = @options

    pluginViews = _.map plugins, (plugin) =>
      @subview(DirectoryPluginItemView, @model, {
        atomType: PowerUpItemType.Description,
        currentPage,
        plugin,
        directoryView
      }, plugin.id)

    @appendSubviews(pluginViews, contentContainer)

    @



// WEBPACK FOOTER //
// ./app/scripts/views/directory/directory-page-view.coffee